/* eslint-disable no-var */
/* eslint-disable react/self-closing-comp */
/* eslint-disable import/no-unresolved */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable arrow-body-style */
import React, { useState } from 'react'
import './Billing.css'
import RefreshIcon from '@mui/icons-material/Refresh';
import { Link } from 'react-router-dom';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { loadStripe } from '@stripe/stripe-js';
import Modal from 'react-bootstrap/Modal';
import {
    Elements
} from '@stripe/react-stripe-js';
import { styled } from '@mui/material/styles';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ShareIcon from '@mui/icons-material/Share';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import AddIcon from '@mui/icons-material/Add';
import MySwiper from '../MySwiper/MySwiper';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import Histroy from './Histroy';
import CreditCardForm from './CreditForm';

const stripePromise = loadStripe('pk_test_51OM5QgHIC6YSoZmKJYiuVcSsPM6QHO7iVNjQi5t0mSudvWzgSdos55tgQyTOmaFrEqdzHYBYpf7SB6aMGahsfVkn00xlfczKqR');

const options = {
    mode: 'payment',
    amount: 1099,
    currency: 'usd',
    appearance: {
    },
};

const Android12Switch = styled(Switch)(({ theme }) => ({
    padding: 8,
    '& .MuiSwitch-track': {
        borderRadius: 22 / 2,
        '&::before, &::after': {
            content: '""',
            position: 'absolute',
            top: '50%',
            transform: 'translateY(-50%)',
            width: 16,
            height: 16,
        },
        '&::before': {
            backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
                theme.palette.getContrastText(theme.palette.primary.main),
            )}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`,
            left: 12,
        },
        '&::after': {
            backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
                theme.palette.getContrastText(theme.palette.primary.main),
            )}" d="M19,13H5V11H19V13Z" /></svg>')`,
            right: 12,
        },
    },
    '& .MuiSwitch-thumb': {
        boxShadow: 'none',
        width: 16,
        height: 16,
        margin: 2,
    },
}));

const Billing = () => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [show1, setShow1] = useState(false);
    const handleClose1 = () => setShow1(false);
    const handleShow1 = () => setShow1(true);


    return (
        <>
            <section className='px-0 pt-4' >
                <div className=''>
                    <h5 className="mb-4 fw-bolder">Company Billing</h5>
                    <div className='row'>
                        <div className='col-md-6 '>
                            <div className='card py-4 border-0'>
                                <p className="card-header">Subscription Plans</p>
                                <div className='card-body'>
                                    <div className='subscription-card'>
                                        <div className='d-flex justify-content-between'>
                                            <h4>Agent Suite <br />Subscription Plan</h4>
                                            <h4>$97 <small>per month</small></h4>
                                        </div>
                                        <hr />
                                        <div className='d-flex justify-content-between'>
                                            <p className='fw-lighter'>Stripe subscription ID:  <br /> <span className='fw-bolder'>sub_XXXXXXXXXXXXXXXXXXXXXXXX</span></p>
                                            <div className='d-flex justify-content-between'>
                                                <div className="button-export mx-1">
                                                    <Button sx={{ backgroundColor: "white", color: "black" }} startIcon={<ContentCopyIcon />} >
                                                        Copy
                                                    </Button>
                                                </div>
                                                <div className="">
                                                    <Button sx={{ backgroundColor: "white", color: "black" }} >
                                                        <ShareIcon />
                                                    </Button>
                                                </div>
                                            </div>
                                        </div>

                                        <p className='text-center w-100 my-4'>Next Billing Date: February 29 2024</p>
                                        <div className="w-100">
                                            <Button sx={{ backgroundColor: "white", color: "black" }} fullWidth>
                                                <a href='#'>Click here </a> &nbsp;  to modify your subscription
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='card py-4 pt-2 my-3 border-0'>
                                <div className='card-header'>
                                    <p className="fw-light text-dark">Payment Methods</p>
                                </div>

                                <div className='card-body px-3'>
                                    <div className='row'>
                                        <div className='col-md-9 px-1'>
                                            <div className='swiper-container'>
                                                <MySwiper />
                                            </div>

                                        </div>
                                        <div className='col-md-3 px-1'>
                                            <div className="button-export mx-1">
                                                <Button variant='filled' className="px-1" fullWidth color='primary' sx={{ backgroundColor: "#63b3ed", color: "white", borderRadius: 0 }} startIcon={<AddIcon />} onClick={handleShow}>
                                                    Add Card
                                                </Button>
                                            </div>
                                            <div className="button-export mt-2">
                                                <Button variant='outline' className="px-1" fullWidth color='primary' sx={{ backgroundColor: "#fff", color: "red", borderRadius: 0, border: '1px solid red', fontSize: "10px" }} >
                                                    Remove Current Card
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='card pt-2 my-3 border-0'>
                                <div className='card-header'>
                                    <p className="fw-light text-dark">Credits</p>
                                    <Button variant="contained" startIcon={<AddCircleOutlineIcon fontSize='small' sx={{ color: '#fff' }} />} onClick={handleShow1}>Add Balance</Button>
                                </div>
                                <div className='card-body'>
                                    <div style={{ background: '#c6f6d5', borderRadius: '6px' }} className='px-4 py-3'>
                                        <div className='d-flex justify-content-between'>
                                            <h6>Total Balance</h6>
                                            <h6 className='fw-bolder'>$4.44</h6>
                                        </div>
                                        <div className='d-flex justify-content-between mt-3'>
                                            <p>Balance:</p>
                                            <p className='fw-bolder'> $4.44</p>
                                        </div>
                                        <div className='d-flex justify-content-between'>
                                            <p>Complimentary Credits:</p>
                                            <p className='fw-bolder'>$0</p>
                                        </div>
                                    </div>

                                    <div className='card-header mt-2'>
                                        <p className="fw-light text-dark fst-italic"><i><RefreshIcon fontSize='small' sx={{ color: 'gray' }} /></i>Refresh</p>
                                        <Link to={'/dashboard/transaction'} style={{ cursor: 'pointer' }}>
                                            <p className="fw-light text-primary">See Transactions</p>
                                        </Link>
                                    </div>

                                    <div className='d-flex justify-content-between mt-4'>
                                        <p>Auto recharge with</p>
                                        <p className='d-flex align-items-center'>$
                                            <select className="form-select ms-2" aria-label="Default select example">
                                                <option selected>10</option>
                                                <option value="1">25</option>
                                                <option value="2">50</option>
                                                <option value="3">100</option>
                                            </select>
                                        </p>
                                    </div>

                                    <div className='d-flex justify-content-between'>
                                        <p>when balance lower than</p>
                                        <p className='d-flex align-items-center'>$
                                            <select className="form-select ms-2" aria-label="Default select example">
                                                <option selected>10</option>
                                                <option value="1">25</option>
                                                <option value="2">50</option>
                                                <option value="3">100</option>
                                            </select>
                                        </p>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className='card scroll py-4 border-0'>
                                <div className='card-header'>
                                    <p className="fw-light text-dark">Billing History</p>
                                    <p className="fw-light text-dark fst-italic"><i><RefreshIcon fontSize='small' sx={{ color: 'gray' }} /></i>Refresh</p>

                                </div>
                                <div className='card-body'>
                                    <Histroy />
                                    <Histroy />
                                    <Histroy />
                                    <Histroy />
                                    <Histroy />
                                    <Histroy />
                                    <Histroy />
                                    <Histroy />
                                    <Histroy />
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            <Modal show={show} onHide={handleClose} centered>
                <Modal.Header closeButton className='border-0'>
                    <Modal.Title className='fw-bold '>Add Card</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Elements stripe={stripePromise} options={options}>
                        <CreditCardForm />
                    </Elements>
                    <h6 className='my-4' style={{ fontSize: '12px' }}>By providing your card information, you allow Agent Suite to charge your card for future payments in accordance with their terms.</h6>
                    <div className='my-4'>
                        <h6>Name</h6>
                        <TextField fullWidth id="outlined-basic" label="Name On Card" variant="outlined" />
                        <div className='d-flex justify-content-end align-items-center mt-2'>
                            <h6>Make this card primary</h6>
                            <FormControlLabel
                                className='ms-2'
                                control={<Android12Switch defaultChecked />}
                            />
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button variant="contained" className='text-white' size="large" color="success">
                        Add Card
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={show1} onHide={handleClose1} centered>
                <Modal.Header closeButton className='border-0'>
                    <Modal.Title className='fw-bold '>Add money to Wallet</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='my-4'>
                        <h6>Amount</h6>
                        <FormControl fullWidth sx={{ m: 1 }} variant="standard">
                            <InputLabel htmlFor="standard-adornment-amount">Amount</InputLabel>
                            <Input
                                id="standard-adornment-amount"
                                startAdornment={<InputAdornment position="start">$</InputAdornment>}
                            />
                        </FormControl>
                        <h6 className='my-4' style={{ fontSize: '12px' }}>Current Balance: $4.44</h6>
                        <h6 className='my-4' style={{ fontSize: '12px' }}>Money will be added to your wallet and your card ending in 3354 will be charged</h6>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose1}>
                        Cancel
                    </Button>
                    <Button variant="contained" className='text-white' size="large" color="success">
                       Proceed
                    </Button>
                </Modal.Footer>
            </Modal>




        </>
    )
}

export default Billing